import { useIntl } from "react-intl";
import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

//Components
import { Button, TableView, Toolbar, ToggleSwitch } from "@gpstrackit/react-controls";
import { Grid, Collapse } from "@mui/material";

//Notification
import { NotificationManager } from "Components/Notifications";
import { HasPermission } from 'Core/security';
//Actions
import { packagesFeaturesSetRoleModules } from 'Redux/actions';

const TablePX = (props) => {
    const { id, indent = 0, template, loading, setChanges, group, subGroup, changes, applyChanges } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const user = useSelector(state => state.securityRedux.user);
    const [expanded, setExpanded] = useState([]);
    const [currentGroup, setCurrentGroup] = useState([])
    const [currentSearch, setCurrentSearch] = useState("");

    const expand = useCallback((nodeId) => {
        let newExpanded = [...expanded];
        if (expanded.includes(nodeId)) {
            newExpanded = expanded.filter(e => e != nodeId);
        } else newExpanded.push(nodeId);
        setExpanded(newExpanded);
    });

    const renderHeader = useCallback((treeView = true) => {
        return (
            <Grid container className="feature-tab-header">
                <Grid item xs={treeView ? 6 : 3}>
                    <span className="feature-tab-header-label" style={{ paddingLeft: treeView ? 25 : 8 }}>{messages['packages_features_feature_name']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_code']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_category']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_included']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_default']}</span>
                </Grid>
            </Grid>
        );
    });

    useEffect(() => {
        if (group?.length) {
            const groupedRoles = Object.entries(
                group.reduce((acc, value) => {
                    if (!acc[value.groupName]) acc[value.groupName] = [];
                    acc[value.groupName].push({ ...value, tempId: `${value.id}-${value.name}` });
                    return acc;
                }, {})
            ).map(([name, groups]) => ({ name, groups, tempId: name }));

            let newGroup = []
            groupedRoles.filter((group) => !group?.name).map((item) => {
                item?.groups.map((item) => { newGroup.push(item) })
            })

            let groupValidation = groupedRoles.filter((item) => item?.name)
            if (groupValidation.length) groupValidation.map((item) => newGroup.push(item))
            setCurrentGroup(newGroup)
        }
    }, [group])

    return (
        <TableView
            name={`features-list-level-${id}`}
            onSearch={(search) => setCurrentSearch(search)}
            data={currentSearch ? template : subGroup?.length ? subGroup : currentGroup.length ? currentGroup : id ? template?.filter((item) => item?.parentModuleId === id) : template?.filter((item) => !item?.parentModuleId) || []}
            loading={(!id && !subGroup?.length) && loading}
            rowsPerPage={100}
            viewType="list"
            messages={messages}
            topSpaceSize={370}
            height={id || subGroup?.length ? "100%" : null}
            inputSearch={!id || subGroup?.length ? true : false}
            containerHeight={id || subGroup?.length ? null : "calc(100% - 100px)"}
            itemSelector={false}
            renderHeader={id || subGroup?.length ? null : renderHeader}
            renderRow={(feature) => {
                let validateModule = template?.some((item) => item?.parentModuleId === feature?.id)
                let featuresModule = template?.filter((item) => item?.parentModuleId === feature?.id)
                return (
                    <div style={{ minWidth: 650 }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            className="row-features"
                        >
                            <Grid item xs={6}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ marginLeft: indent, paddingTop: 7, paddingBottom: 7 }}
                                    wrap="nowrap"
                                >
                                    <Grid item>
                                        {
                                            feature?.groups?.length || (!id && validateModule) && !currentSearch ?
                                                <Button
                                                    type="icon"
                                                    icon={expanded.includes(feature.id) || expanded.includes(feature.tempId) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
                                                    placement="bottom"
                                                    className="btn-xs"
                                                    fontSize="inherit"
                                                    onClick={() => {
                                                        let currentId = feature?.tempId || feature.id
                                                        expand(currentId)
                                                    }}
                                                /> :
                                                <div style={{ width: 24, height: 24 }}></div>
                                        }
                                    </Grid>
                                    <Grid item xs>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="flex-start"
                                            className="context-menu-container"
                                            wrap="nowrap"
                                        >
                                            <Grid item zeroMinWidth><span>{`${feature?.name}`}</span></Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs>
                                <span style={{ marginLeft: 5, fontWeight: 'bold' }}>{feature?.code}</span>
                            </Grid>
                            <Grid item xs>
                                <span style={{ marginLeft: 5, fontWeight: 'bold' }}>{messages[feature?.category] || feature?.category || messages['packages_features_group']}</span>
                            </Grid>
                            <Grid item xs>
                                <span style={{ marginLeft: 5 }}>
                                    <ToggleSwitch
                                        id={`update-included-feature-${feature?.id || feature?.tempId?.replace(/\s+/g, "")}`}
                                        medium
                                        blueToggle
                                        optionLabels={[messages['packages_features_included'], messages['packages_features_optional']]}
                                        checked={feature?.groups ? !feature.groups.some((item) => !item?.r) : feature?.r || feature?.code === "realtimemaps"}
                                        onChange={(checked) => {
                                            let currentRoleModules = JSON.parse(JSON.stringify(template));
                                            //Update of the groups
                                            if (feature?.groups && !currentSearch) {
                                                currentRoleModules = currentRoleModules.map(item => {
                                                    const item2 = feature?.groups.find(i2 => i2.id === item.id);
                                                    return item2 ? { ...item, r: checked, isDefault: !checked ? false : item?.isDefault } : item;
                                                })
                                            } else {
                                                //Update of the current feature
                                                if (!loading && feature?.code !== "realtimemaps") {
                                                    let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);
                                                    if (indexItem > -1) {
                                                        currentRoleModules[indexItem].r = checked
                                                        if (!checked) {
                                                            currentRoleModules[indexItem].isDefault = false
                                                        }
                                                    }
                                                }
                                                //Updating of children
                                                if (!checked) {
                                                    if (!feature?.parentModuleId) {
                                                        currentRoleModules = currentRoleModules.map((item) => {
                                                            if (item?.parentModuleId === feature?.id) {
                                                                return { ...item, r: checked, isDefault: !checked ? false : item?.isDefault }
                                                            } else return { ...item }
                                                        })
                                                    }
                                                }

                                            }
                                            setChanges(true);
                                            dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                        }}
                                    />
                                </span>
                            </Grid>
                            <Grid item xs>
                                <span style={{ marginLeft: 5 }}>
                                    <ToggleSwitch
                                        id={`update-default-feature-${feature?.id || feature?.tempId?.replace(/\s+/g, "")}`}
                                        medium
                                        blueToggle
                                        optionLabels={[messages['packages_features_active'], messages['packages_features_optional']]}
                                        checked={feature?.groups ? !feature.groups.some((item) => !item?.isDefault) : feature?.isDefault || feature?.code === "realtimemaps"}
                                        onChange={(checked) => {
                                            let currentRoleModules = JSON.parse(JSON.stringify(template));
                                            if (feature?.groups && !currentSearch) {
                                                currentRoleModules = currentRoleModules.map(item => {
                                                    const item2 = feature?.groups.find(i2 => i2.id === item.id);
                                                    return item2 ? { ...item, isDefault: checked } : item;
                                                });

                                                let validateIncluded = feature.groups.some((item) => !item?.r)
                                                if (validateIncluded) {
                                                    NotificationManager.warning(
                                                        messages['packages_features_the_group_must_be_included'],
                                                        messages['packages_features_title'],
                                                        3000
                                                    );
                                                    return
                                                }
                                                dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                            } else {
                                                if (!loading && feature?.code !== "realtimemaps") {
                                                    setChanges(true);
                                                    let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);
                                                    if (indexItem > -1) {
                                                        if (currentRoleModules[indexItem].r) {
                                                            currentRoleModules[indexItem].isDefault = checked
                                                        } else {
                                                            NotificationManager.warning(
                                                                messages['packages_features_the_feature_mush_have_the_read'],
                                                                messages['packages_features_title'],
                                                                3000
                                                            );
                                                            return
                                                        }
                                                    }

                                                    //Updating of children
                                                    if (!checked) {
                                                        if (!feature?.parentModuleId) {
                                                            currentRoleModules = currentRoleModules.map((item) => {
                                                                if (item?.parentModuleId === feature?.id) {
                                                                    return { ...item, isDefault: checked }
                                                                } else return { ...item }
                                                            })
                                                        }
                                                    }
                                                    dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                                }
                                            }
                                        }}
                                    />
                                </span>
                            </Grid>
                        </Grid>
                        {
                            !currentSearch &&
                            <Collapse in={expanded.includes(feature.id) || expanded.includes(feature.tempId)} timeout="auto" unmountOnExit>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ padding: '0px 0px 0px 0px' }}
                                >
                                    <TablePX
                                        id={feature.id}
                                        indent={indent + 30}
                                        loading={loading}
                                        template={template}
                                        setChanges={setChanges}
                                        group={featuresModule.length ? featuresModule : null}
                                        subGroup={feature.groups}
                                    />
                                </Grid>
                            </Collapse>
                        }
                    </div >
                )
            }}
            pagination={false}
            toolbarContainerClassName='table-feature-toolbar-container'
            extraToolbar={(id || subGroup?.length) ? null : () => {
                return (
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ height: 45, padding: 10 }}
                    >
                        <Grid item xs={6}></Grid>
                        <Grid item xs></Grid>
                        <Grid item xs style={{ display: 'flex', justifyContent: 'space-around' }}><span style={{ fontWeight: 'bold' }}>{messages['packages_features_all']}</span></Grid>
                        <Grid item xs>
                            <ToggleSwitch
                                id="update-all-included-feature"
                                medium
                                blueToggle
                                optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                checked={!loading ? !template?.some((item) => !item?.r) : false}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));
                                        let newRoleModules = currentRoleModules
                                        if (!checked) newRoleModules = currentRoleModules.map((item) => ({ ...item, isDefault: false }));
                                        let newList = newRoleModules.map((item) => ({ ...item, r: checked }));
                                        dispatch(packagesFeaturesSetRoleModules([...newList]));
                                        setChanges(true);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs>
                            <ToggleSwitch
                                id="update-all-default-feature"
                                medium
                                blueToggle
                                optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                checked={!loading ? !template?.some((item) => !item?.isDefault) : false}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));
                                        let validateRead = currentRoleModules.some((item) => item.r !== true);
                                        let newRoleModules = currentRoleModules.map((item) => ({ ...item, isDefault: checked }));
                                        if (validateRead) {
                                            NotificationManager.warning(
                                                messages['packages_features_all_features_must_have_read_permission_check'],
                                                messages['packages_features_title'],
                                                3000
                                            );
                                        } else {
                                            dispatch(packagesFeaturesSetRoleModules([...newRoleModules]));
                                            setChanges(true);
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                )
            }}
        >
            {
                !id && !subGroup?.length && (
                    <Toolbar>
                        <div>
                            {
                                changes &&
                                <Button
                                    className="btn-dark-blue"
                                    onClick={() => applyChanges()}
                                    style={{ margin: -5 }}
                                    disabled={!HasPermission(user, "rolft", "u") || loading}
                                >
                                    {messages['packages_features_save_changes']}
                                </Button>
                            }
                        </div>
                    </Toolbar>
                )
            }
        </TableView>
    );
};

export default TablePX